/** Blink-style data match: 0=unchecked, 1=mismatch, 2=match, 3=partial. */
export type DataMatchState = 0 | 1 | 2 | 3

export type MrzCurpCrossCheck = {
  state: DataMatchState
  states: string[]
  birthDateMatch: boolean | null
  sexMatch: boolean | null
  curpPresent: boolean
  mrzPresent: boolean
}

function curpSexToMrz(sex: string): string | null {
  if (sex === 'H') return 'M'
  if (sex === 'M') return 'F'
  return null
}

function normalizeYyMmDd(value: string): string {
  return String(value || '')
    .replace(/\D/g, '')
    .slice(-6)
}

/** Cross-check front CURP vs back MRZ birthdate and sex. */
export function crossCheckMrzCurp(
  curp: string,
  mrz?: { dateOfBirth?: string; gender?: string } | null,
): MrzCurpCrossCheck {
  const curpNorm = String(curp || '')
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '')
  const mrzPresent = !!mrz && typeof mrz === 'object'
  const curpPresent = curpNorm.length >= 11

  if (!curpPresent || !mrzPresent) {
    return {
      state: 0,
      states: curpPresent || mrzPresent ? ['cross_check_skipped_incomplete'] : [],
      birthDateMatch: null,
      sexMatch: null,
      curpPresent,
      mrzPresent,
    }
  }

  const curpBirth = curpNorm.slice(4, 10)
  const curpSex = curpNorm[10]
  const mrzBirth = normalizeYyMmDd(mrz!.dateOfBirth ?? "")
  const mrzSex = String(mrz!.gender || '')
    .trim()
    .charAt(0)
    .toUpperCase()

  const birthDateMatch = curpBirth.length === 6 && mrzBirth.length === 6 ? curpBirth === mrzBirth : null
  const expectedMrzSex = curpSexToMrz(curpSex)
  const sexMatch = expectedMrzSex && (mrzSex === 'M' || mrzSex === 'F') ? expectedMrzSex === mrzSex : null

  const states: string[] = []
  if (birthDateMatch === true) states.push('birthdate_match')
  else if (birthDateMatch === false) states.push('birthdate_mismatch')
  if (sexMatch === true) states.push('sex_match')
  else if (sexMatch === false) states.push('sex_mismatch')

  let state: DataMatchState = 0
  const checks = [birthDateMatch, sexMatch].filter((v) => v !== null) as boolean[]
  if (checks.length === 0) {
    state = 0
  } else if (checks.every(Boolean)) {
    state = 2
  } else if (checks.some(Boolean) && checks.some((v) => !v)) {
    state = 3
  } else {
    state = 1
  }

  return {
    state,
    states,
    birthDateMatch,
    sexMatch,
    curpPresent,
    mrzPresent,
  }
}
